/**
 * 路径与组件、标签的映射配置
 * 用于标签页架构下的路由解析
 */
import {
  Dashboard,
  Blacklist,
  AdsRecords,
  GoogleAds,
  IdleAccounts,
  EmailManagement,
  MySettings,
  PermissionManagement,
  Profile,
  OfferDetail,
  OfferEdit,
  RecommendedOffers,
  PostBack,
} from "../utils/lazyImports";

const staticRoutes = [
  { path: "/", label: "Campaigns", component: Dashboard },
  { path: "/dashboard", label: "Campaigns", component: Dashboard },
  { path: "/blacklist", label: "黑名单", component: Blacklist },
  { path: "/ads-records", label: "Google Ads", component: AdsRecords },
  { path: "/google-ads", label: "账户列表", component: GoogleAds },
  { path: "/idle-accounts", label: "空闲账号", component: IdleAccounts },
  { path: "/email-management", label: "邮箱管理", component: EmailManagement },
  { path: "/settings", label: "配置信息", component: MySettings },
  { path: "/permission-management", label: "权限分配", component: PermissionManagement },
  { path: "/profile", label: "个人中心", component: Profile },
  { path: "/recommended-offers", label: "收藏Offer", component: RecommendedOffers },
  { path: "/post-back", label: "Post Back", component: PostBack },
];

const dynamicPatterns = [
  { pattern: /^\/offers\/([^/]+)\/edit$/, label: "编辑Offer", component: OfferEdit },
  { pattern: /^\/offers\/([^/]+)$/, label: "Offer详情", component: OfferDetail },
];

const staticMap = Object.fromEntries(
  staticRoutes.map((r) => [r.path === "/" ? "/dashboard" : r.path, r.label])
);

const pathToLabelFn = (path) => {
  const normalized = path === "/" ? "/dashboard" : path;
  if (staticMap[normalized]) return staticMap[normalized];
  for (const { pattern, label } of dynamicPatterns) {
    if (pattern.test(normalized)) return label;
  }
  return "未命名";
};

export const getPathToLabel = () => pathToLabelFn;

export const getComponentForPath = (path) => {
  const normalized = path === "/" ? "/dashboard" : path;
  const staticRoute = staticRoutes.find((r) => (r.path === "/" ? "/dashboard" : r.path) === normalized);
  if (staticRoute) return { component: staticRoute.component, props: {} };
  for (const { pattern, component } of dynamicPatterns) {
    const match = normalized.match(pattern);
    if (match) {
      const params = match[1] ? { id: match[1] } : {};
      return { component, props: params };
    }
  }
  return null;
};

const pathToPreloadMap = {
  "/": () => import("../pages/Dashboard"),
  "/dashboard": () => import("../pages/Dashboard"),
  "/blacklist": () => import("../pages/Blacklist"),
  "/ads-records": () => import("../pages/AdsRecords"),
  "/google-ads": () => import("../pages/GoogleAds"),
  "/idle-accounts": () => import("../pages/IdleAccounts"),
  "/email-management": () => import("../pages/EmailManagement"),
  "/settings": () => import("../pages/MySettings"),
  "/permission-management": () => import("../pages/PermissionManagement"),
  "/recommended-offers": () => import("../pages/RecommendedOffers"),
  "/post-back": () => import("../pages/PostBack"),
  "/profile": () => import("../pages/Profile"),
};

export const preloadPageForPath = (path) => {
  const normalized = path === "/" ? "/dashboard" : path;
  const loader = pathToPreloadMap[normalized];
  if (loader) loader();
};

export const pathConfig = {
  staticRoutes,
  dynamicPatterns,
  getPathToLabel,
  getComponentForPath,
  preloadPageForPath,
};

export default pathConfig;
